const ADULT_AGE_YEARS = 18;

/** Age in whole years at `asOf`, or null when DOB is missing or invalid. */
export function getStudentAgeYears(
  dateOfBirth: Date | string | null | undefined,
  asOf: Date = new Date()
): number | null {
  if (dateOfBirth == null) return null;
  const dob = dateOfBirth instanceof Date ? dateOfBirth : new Date(dateOfBirth);
  if (Number.isNaN(dob.getTime())) return null;

  let age = asOf.getFullYear() - dob.getFullYear();
  const monthDiff = asOf.getMonth() - dob.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && asOf.getDate() < dob.getDate())) {
    age -= 1;
  }
  return age;
}

export function isAdultStudentByDateOfBirth(
  dateOfBirth: Date | string | null | undefined
): boolean {
  const age = getStudentAgeYears(dateOfBirth);
  return age !== null && age >= ADULT_AGE_YEARS;
}

/** Whether roster/enrollment UI should show parent/guardian contact lines. */
export function shouldShowEnrollmentGuardian(params: {
  isSelf?: boolean;
  isAdultStudent?: boolean;
  dateOfBirth?: Date | string | null;
  isManual?: boolean;
  hasLinkedGuardian?: boolean;
}): boolean {
  if (params.isManual === true && !params.hasLinkedGuardian) return false;
  if (params.isSelf === true) return false;
  if (params.isAdultStudent === true) return false;
  if (isAdultStudentByDateOfBirth(params.dateOfBirth)) return false;
  return true;
}
